import createFetchTypes from '@app/utils/createFetchTypes';
import {
	InquiryFormTemplateFieldDataType,
	InquiryFormTemplateFieldInputType,
	InquiryFormTemplateTypes,
} from './constants';
import { StorytellerType } from '../storyteller/types';

export type InquiryFormTemplateFieldType = {
	displayName: string;
	internalName: string;
	dataType: InquiryFormTemplateFieldDataType;
	inputType: InquiryFormTemplateFieldInputType;
	isRequired: boolean;
	order: number;
	selectOptions?: string[];
};

export type InquiryFormTemplateType = {
	id?: string;
	name: string;
	type: InquiryFormTemplateTypes;
	formFields: InquiryFormTemplateFieldType[];
	teams: string[];
	//These fields below we cannot update from web app side, they are set by the backend automatically.
	workspace: string;
	location: string;
	deleted: boolean;
	createdBy: StorytellerType;
	updatedBy: string;
	createdAt: Date;
	updatedAt: Date;
	aiBotsWithTriggers: string[];
};

export type InquiryFormTemplateInstanceType = {
	campaign: string;
	createdBy: string;
	form: InquiryFormTemplateType;
	formFields: InquiryFormTemplateFieldType[];
	headerText?: string;
	id: string;
	workspace: string;
	_id: string;
};

const mainType = 'inquiryFormTemplates';

export const createInquiryFormTemplateTypes = createFetchTypes(
	`${mainType}_CREATE_INQUIRY_FORM_TEMPLATE`,
);

export const updateInquiryFormTemplateTypes = createFetchTypes(
	`${mainType}_UPDATE_INQUIRY_FORM_TEMPLATE`,
);

export const getInquiryFormTemplatesTypes = createFetchTypes(
	`${mainType}_GET_INQUIRY_FORM_TEMPLATES`,
);

export const deleteInquiryFormTemplateTypes = createFetchTypes(
	`${mainType}_DELETE_INQUIRY_FORM_TEMPLATE`,
);
